import React from "react";

function Enrollment() {
  return (
    <>
      <h2 className="mt-32 text-6xl text-center">Do you want to Enroll?</h2>
    </>
  );
}

export default Enrollment;
